export default __webpack_public_path__ + "static/precision-piece-1-ff2c0f63942203b6d28e4b635fbc30cd.jpg";